import React from "react";
import styled from "styled-components";

const TitleWrapper = styled.div`
  h1 {
    color: var(--primary);
    font-size: 2rem;
    letter-spacing: 2px;
    font-weight: normal;
    padding: 2rem;
  }
  h2,
  p {
    text-align: center;
  }
  h2 {
    font-size: 4rem;
    margin: 3rem 0;
  }
`;

const Title = () => {
  return (
    <TitleWrapper>
      <h1>FireGram</h1>
      <h2>Your Pictures</h2>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
    </TitleWrapper>
  );
};

export default Title;
